"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TronUpToken = exports.TronWrappedToken = exports.TronNativeToken = void 0;
const utils_1 = require("@unifiprotocol/utils");
exports.TronNativeToken = new utils_1.Currency("TRX", 6, "TRX", "TRX");
exports.TronWrappedToken = new utils_1.Currency("TNUC9Qb1rRpS5CbWLmNMxXBjyFoydXjWFR", 6, "WTRX", "Wrapped TRX");
exports.TronUpToken = new utils_1.Currency("TJ93jQZibdB3sriHYb5nNwjgkPPAcFR7ty", 6, "UP", "UP");
